Vue.component('panel-geolocation', {
	props: ["options", "labellang"],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutDown" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="panel-geolocation" class="panel-widget" :class="{ \'full\': this.options.supportGeolocation  }">' +
		'<div class="overlay-content text-center">' +
		'<h3>{{ title }}</h3>' +
		'<div v-if="options.supportGeolocation" class="google-map" :id="mapName"></div>' +
		'<p v-else class="error-msg">{{ options.errorGeolation || labellang.error_location }}</p>' +
		'</div>' +
		'<div class="overlay-footer">' +
		'<button v-if="btCancelVisible" @click="closeViewNoPosition" class="btn pull-left" > {{ cancel }} </button>' +
		'<button v-if="options.supportGeolocation" @click.once="sendWidget"   class="btn btn-info pull-right"  data-language="send" >{{ send }}</button>' +
		'</div>' +
		'</div>' +
		'<div v-html="scriptsGoogle"></div>' +
		'</div>' +
		'</transition>',

	data: function () {
		return {
			isActive: false,
			title: this.labellang.title_geolocation || 'Share your position:',
			send: this.labellang.webcb_send_button,
			cancel: this.labellang.cancel,
			btCancelVisible: false,
			apiGoogle: '',
			scriptsGoogle: '',
			mapName: 'google-map',
			dataPos:null,
			markerLat:null,
			markerLng:null,
			currentPosLat:null,
			currentPosLng:null,
			currentPosMarker:null,
			elementMap:null,
			optionMap: {},
			instanceMap:null,
			instamceMarker:null,

		}
	},
	mounted: function () {
		var that = this;

		bus.$on('onShowPanelGeoLocation', function (val) {
			Vue.nextTick(function () {
				if(val == true){ // fix problem that finded the id map also the panel is closing
				 that.checkLocation();
				}
				that.contentShow(val);
			})
		})
	},
	methods: {
		checkLocation: function () {
			var that = this;
			if (this.options.supportGeolocation) {
				setTimeout(function(){
					that.initGoogleMap()
				},300)
			}
			else{
				this.btCancelVisible = true;
			}

		},
		initGoogleMap: function () {
			var that = this;
			this.elementMap = document.getElementById(this.mapName)
			this.optionsMap = {
				zoom: 14,
				center: new google.maps.LatLng(this.options.pos.lat, this.options.pos.lng)
			}
			this.instanceMap = new google.maps.Map(this.elementMap, this.optionsMap);
			//var infoWindow = new google.maps.InfoWindow;
			this.instamceMarker = new google.maps.Marker(
				{
				  position: this.options.pos,
				  map: this.instanceMap,
				  title:"",
				  draggable:true,

				}
			)
			this.instamceMarker.setMap(this.instanceMap);
			
			google.maps.event.addListener(this.instamceMarker, 'dragend', function (evt) {
				that.markerLat = evt.latLng.lat().toFixed(3)
				that.markerLng = evt.latLng.lng().toFixed(3)
			});
			 

		},
		contentShow: function (val) {
			this.isActive = val;
		},
		closeViewNoPosition: function () {
			this.dataPos = this.options.errorGeolation || this.labellang.error_location; //fix for ie11
			bus.$emit("onCloseWidget", this.dataPos);
			this.isActive = false;
		},
		removeMap:function(){
			this.instanceMap = null;
			this.instamceMarker = null
		},
		sendWidget: function () {
			if(this.options.supportGeolocation){ // if i move the marker i get the postion from marker
				if( this.markerLat && this.markerLng ){
					this.currentPosLat = this.markerLat
					this.currentPosLng = this.markerLng
				}else{
					this.currentPosLat = this.options.pos.lat
					this.currentPosLng = this.options.pos.lng
				}
				this.dataPos = ("Lat:"+this.currentPosLat + "&Long:"+ this.currentPosLng )
			};
			bus.$emit("onCloseWidget", this.dataPos);
			this.removeMap();
			this.isActive = false;
		}
	}
})